import { useTranslation } from 'react-i18next';
import { Button } from '../components/Button';
import './AppSourceReviews.css';

export function AppSourceReviews() {
  const { t } = useTranslation();

  return (
    <section id="reviews" className="section">
      <div className="container">
        <div className="section-header">
          <span className="eyebrow">{t('reviews.eyebrow')}</span>
          <h2>{t('reviews.title')}</h2>
          <p>{t('reviews.subtitle')}</p>
        </div>

        <div className="reviews-placeholder">
          <div className="reviews-placeholder__rating" aria-hidden="true">
            {[0, 1, 2, 3, 4].map((i) => (
              <svg key={i} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" opacity="0.3"/>
              </svg>
            ))}
          </div>
          <h3 className="reviews-placeholder__title">{t('reviews.placeholderTitle')}</h3>
          <p className="reviews-placeholder__body">{t('reviews.placeholderBody')}</p>
          <Button as="a" href="#waitlist" size="md">{t('reviews.cta')}</Button>
        </div>
      </div>
    </section>
  );
}
